import {Component, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmDialogComponent} from '../../dialog/confirm-dialog/confirm-dialog.component';
import {RelayBoard} from '../../../classes/RelayBoard';
import {RelayBoardService} from '../../../services/relay-board.service';
import {RelayBoardEditComponent} from '../relay-board-edit/relay-board-edit.component';
import {OfficeService} from '../../../services/office.service';
import {Office} from '../../../classes/Office';

@Component({
  selector: 'app-relay-board-list',
  styleUrls: ['./relay-board-list.component.scss'],
  templateUrl: './relay-board-list.component.html',
})
export class RelayBoardListComponent implements OnInit {

  public relayBoards: RelayBoard[];
  public errorMessage: string;
  private currentDialog = null;
  public offices: Map<number, Office>;

  constructor(private relayBoardService: RelayBoardService,
              private modalService: NgbModal,
              private officeService: OfficeService) {
  }

  ngOnInit(): void {
    this.updateList();
    this.officeService.getAll()
      .subscribe((response: Office[]) => this.offices = new Map(response.map(office => [office.id, office])));
  }

  private updateList(): void {
    this.relayBoardService.getAll()
      .subscribe({
        next: (response: RelayBoard[]) => this.relayBoards = response,
        error: (error) => this.errorMessage = error.error.error
      });
  }

  openEditModal(relayBoard: RelayBoard): void {
    this.currentDialog = this.modalService.open(RelayBoardEditComponent,
      {
        scrollable: true,
        windowClass: 'modal-relay-board-edit',
        size: 'lg',
        centered: true,
      });

    this.currentDialog.componentInstance.relayBoard = relayBoard;

    this.currentDialog.result.then(
      (result) => {
        if (result instanceof FormGroup) {
          const editedRelayBoard = new RelayBoard(result.value);

          this.relayBoardService.addOrEdit(editedRelayBoard).subscribe({
            next: () => this.updateList(),
            error: (error) => this.errorMessage = error.error.error
          });
        }
      },
      (error) => { console.log('Dialog close error: ' + error); }
    );
  }

  openDeleteConfirmModal(relayBoard: RelayBoard): void {
    this.currentDialog = this.modalService.open(ConfirmDialogComponent,
      {
        scrollable: true,
        windowClass: 'modal-confirm',
        size: 'md',
        centered: true,
        // keyboard: false,
        // backdrop: 'static'
      });

    this.currentDialog.componentInstance.message =
      'Are you sure that you want to delete relay board ' + relayBoard.name + '?';

    this.currentDialog.result.then((result) => {
      if (result.status === 'confirmed') {
        this.relayBoardService.delete(relayBoard.id).subscribe({
          next: () => this.updateList(),
          error: (error) => this.errorMessage = error.error.error
        });
      }
    }, (error) => {
      console.log('Dialog close error: ' + error);
    });
  }

  getOfficeName(officeId: number): string {
    const office = this.offices.get(officeId);
    return office.city + ', ' + office.address;
  }
}
